import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import type { ProposalTemplateTeamChoices } from "work/proposal-templates/_api/save-proposal-template-api-request";
import { ProposalTemplateParty } from "work/proposal-templates/proposal-template";

export const INCLUDE_OWN_TEAM_LABEL = "Include our team";
export const INCLUDE_TEAM_TEMPLATES_LABEL = "Include the team templates applied to it";

/** "Include the vendor team" for a client, "Include the client team" for a firm. */
export function includeOtherTeamLabel(party: ProposalTemplateParty): string {
  return `Include the ${party === ProposalTemplateParty.Vendor ? "client" : "vendor"} team`;
}

/**
 * The team options in Save as Proposal Template (#6637): the saver's own team, on by default, and the
 * other party's, off by default, with the team templates applied to it.
 */
export default function ProposalTemplateTeamChoicesFields(props: Readonly<{
  party: ProposalTemplateParty;
  choices: ProposalTemplateTeamChoices;
  disabled?: boolean;
  onChange: (choices: ProposalTemplateTeamChoices) => void;
}>) {
  const { party, choices, disabled, onChange } = props;
  return (
    <FormGroup sx={{ mt: 1 }}>
      <FormControlLabel
        label={INCLUDE_OWN_TEAM_LABEL}
        disabled={disabled}
        control={
          <Checkbox
            checked={choices.ownTeam}
            onChange={(event) => onChange({ ...choices, ownTeam: event.target.checked })}
          />
        }
      />
      <FormControlLabel
        label={includeOtherTeamLabel(party)}
        disabled={disabled}
        control={
          <Checkbox
            checked={choices.otherTeam}
            onChange={(event) =>
              onChange({
                ...choices,
                otherTeam: event.target.checked,
                // Its templates go with it: they mean nothing without the team they were applied to.
                otherTeamTemplates: event.target.checked && choices.otherTeamTemplates,
              })
            }
          />
        }
      />
      <FormControlLabel
        sx={{ pl: 3 }}
        label={INCLUDE_TEAM_TEMPLATES_LABEL}
        disabled={disabled || !choices.otherTeam}
        control={
          <Checkbox
            checked={choices.otherTeamTemplates}
            onChange={(event) => onChange({ ...choices, otherTeamTemplates: event.target.checked })}
          />
        }
      />
      {choices.otherTeam && (
        <FormHelperText>
          The template keeps who they are, not their details. A draft started from it leaves out and lists anybody who
          has left their organization or can no longer lead.
        </FormHelperText>
      )}
    </FormGroup>
  );
}
